import React, { PureComponent } from 'react';
import { bool, func, string, arrayOf, shape } from 'prop-types';
import { Box, ButtonBase, DialogTitle, IconButton, Menu } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IntlMessages from '../../../../util/IntlMessages';

class DialogHeader extends PureComponent {
  static propTypes = {
    routes: arrayOf(
      shape({
        active: bool,
        busId: string,
        campus: string,
        id: string,
        inAlarm: bool,
        name: string,
        needAttention: bool,
        number: string,
        online: bool,
        state: string,
      }),
    ),
    onClose: func,
    toRoute: bool,
  };

  static defaultProps = {
    routes: [],
    onClose: () => {},
    toRoute: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      routesMenuAnchor: null,
    };
  }

  openRoutesMenu = event => {
    this.setState({ routesMenuAnchor: event.currentTarget });
  };

  closeRoutesMenu = () => {
    this.setState({ routesMenuAnchor: null });
  };

  render() {
    const { toRoute, routes, onClose } = this.props;
    const { routesMenuAnchor } = this.state;

    return (
      <DialogTitle id="form-dialog-title" className="dialog-title">
        {toRoute && routes.length ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box component="ul" sx={{ mb: 0, pl: 0, listStyle: 'none' }}>
              <Box
                component="li"
                sx={{ display: 'inline-block', '&:not(:last-child)': { mr: '0.5rem' } }}
              >
                <ButtonBase
                  disableRipple
                  className="quick-menu"
                  sx={{ m: 0 }}
                  onClick={this.openRoutesMenu}
                >
                  <Box
                    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    className="pointer"
                  >
                    <p>
                      <IntlMessages id="dialog.notices.routeTitle" />
                      {routes.length}
                      <IntlMessages
                        id={
                          routes.length === 1
                            ? 'dialog.notices.routeTitle.route'
                            : 'dialog.notices.routeTitle.routes'
                        }
                      />
                    </p>
                    <Box
                      component="i"
                      className="zmdi zmdi-caret-down zmdi-hc-fw"
                      sx={{ flexGrow: 0, flexShrink: 0 }}
                    />
                  </Box>
                </ButtonBase>

                <Menu
                  anchorEl={routesMenuAnchor}
                  open={Boolean(routesMenuAnchor)}
                  onClose={this.closeRoutesMenu}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  MenuListProps={{ component: 'div' }}
                >
                  <div className="messages-list notice-dropdown-menu">
                    <Box component="ul" sx={{ pl: 0, listStyle: 'none' }}>
                      {routes.map(route => (
                        <li key={route.id}>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box component="h4" sx={{ mb: 0, ml: 1 }}>
                              {route.number}
                            </Box>
                          </Box>
                        </li>
                      ))}
                    </Box>
                  </div>
                </Menu>
              </Box>
            </Box>
          </Box>
        ) : (
          <IntlMessages id="dialog.notices.title" />
        )}
        <IconButton color="inherit" onClick={onClose} aria-label="Close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
    );
  }
}

export default DialogHeader;
